import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { ClipboardTypes } from '@suite/common/enums/clipboard-types';
import { LanguageSettings } from '@suite/common/services/language-settings';
import { NomWebServicesJson } from '@suite/common/services/nom-web-services-json';

@Component({
    selector: 'st-clipboard-source-chooser',
    templateUrl: './clipboard-source-chooser-modal.component.html',
    styleUrls: ['./clipboard-source-chooser-modal.component.scss'],
    host: {
        class: 'st-clipboard-source-chooser-modal',
    },
    encapsulation: ViewEncapsulation.None,
})
export class ClipboardSourceChooserComponent implements OnInit {
    selectedClipboardSource: { [id: string]: StorytellingExportFormatRecord };
    private _type: ClipboardTypes;
    get type(): ClipboardTypes {
        return this._type;
    }
    set type(type: ClipboardTypes) {
        this._type = type;
        if (this.nomWebServicesJson.HelloResults.PersonalExportFormatTemplates[this.type]) {
            this.selectedClipboardSource = this.nomWebServicesJson.HelloResults.PersonalExportFormatTemplates;
        } else if (this.nomWebServicesJson.HelloResults.TeamClipboardTemplates[this.type]) {
            this.selectedClipboardSource = this.nomWebServicesJson.HelloResults.TeamExportFormatTemplates;
        } else {
            this.selectedClipboardSource = this.nomWebServicesJson.HelloResults.EnterpriseExportFormatTemplates;
        }
    }

    constructor(
        public nomWebServicesJson: NomWebServicesJson,
        public languageSettings: LanguageSettings,
        public dialogRef: DialogRef,
        @Inject(DIALOG_DATA) public data: { type: ClipboardTypes }
    ) {}

    ngOnInit() {
        this.type = this.data.type;
    }

    applyType() {
        this.dialogRef.close(this.selectedClipboardSource);
    }

    close() {
        this.dialogRef.close();
    }
}
